import { ajax } from '@rails/ujs';
import BuyerPopoverController from './buyer_popover_controller';

export default class extends BuyerPopoverController {
  fetchPopoverContent() {
    const id = this.element.dataset.id;

    ajax({
      url: `/admin/popovers/sellers/${id}`,
      type: 'GET',
      dataType: 'script'
    });
  }
}
